export default "__VITE_ASSET__Dkq7KvWn__"